import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "../../styles/FAQ/FAQ.css";

const faqData = [
  {
    category: "General",
    questions: [
      {
        question: "What is the Phabyéonj'n-pierre Foundation?",
        answer:
          "The Phabyéonj'n-pierre Foundation is a non-profit organization dedicated to empowering communities through education, health initiatives, and sustainable development programs. We work to create lasting positive change in underserved communities.",
      },
      {
        question: "How can I get involved with the foundation?",
        answer:
          "There are many ways to get involved! You can volunteer your time, make a donation, become a partner organization, or participate in our programs. Visit our Partnerships page or contact us directly to learn more about opportunities.",
      },
      {
        question: "Where does the foundation operate?",
        answer:
          "We operate both locally and internationally, focusing on communities that need support the most. Our programs span across education, healthcare, and community development initiatives in various regions.",
      },
    ],
  },
  {
    category: "Donations",
    questions: [
      {
        question: "How do I make a donation?",
        answer:
          "You can make a secure donation through our website by clicking the 'Donate' button in the navigation menu. We accept one-time and recurring donations via credit card, debit card, and other payment methods through our secure payment processor.",
      },
      {
        question: "Is my donation tax-deductible?",
        answer:
          "Yes! The Phabyéonj'n-pierre Foundation is a registered 501(c)(3) non-profit organization. All donations are tax-deductible to the extent allowed by law. You will receive a receipt for your donation that you can use for tax purposes.",
      },
      {
        question: "How is my donation used?",
        answer:
          "We are committed to transparency and accountability. Your donations directly support our programs in education, healthcare, and community development. Administrative costs are kept to a minimum to ensure maximum impact. You can view our annual reports for detailed information on fund allocation.",
      },
      {
        question: "Can I donate to a specific program?",
        answer:
          "Yes! When making a donation, you can specify which program or initiative you'd like to support, such as scholarships, health initiatives, or community development. If you prefer, you can also make a general donation that allows us to allocate funds where they're needed most.",
      },
    ],
  },
  {
    category: "Programs & Scholarships",
    questions: [
      {
        question: "What scholarship programs do you offer?",
        answer:
          "We offer various scholarship programs for students at different educational levels, from primary school to university. Our scholarships cover tuition, books, supplies, and in some cases, living expenses. Eligibility criteria vary by program.",
      },
      {
        question: "How do I apply for a scholarship?",
        answer:
          "Scholarship applications are typically available on our website during designated application periods. You'll need to complete an application form, submit required documentation (transcripts, recommendation letters, etc.), and meet specific eligibility criteria. Check our Programs page for current opportunities.",
      },
      {
        question: "What other programs does the foundation offer?",
        answer:
          "Beyond scholarships, we offer health and wellness programs, community development initiatives, vocational training, mentorship programs, and various educational workshops. Each program is designed to create sustainable, positive change in the communities we serve.",
      },
    ],
  },
  {
    category: "Volunteering & Partnerships",
    questions: [
      {
        question: "What volunteer opportunities are available?",
        answer:
          "We offer diverse volunteer opportunities including teaching, mentoring, administrative support, event coordination, fundraising, and program support. Both on-site and remote opportunities are available depending on the role and your location.",
      },
      {
        question: "How can my organization become a partner?",
        answer:
          "We welcome partnerships with organizations that share our mission and values. Corporate sponsors, educational institutions, healthcare providers, and community organizations can all become partners. Contact us through our Partnerships page to discuss collaboration opportunities.",
      },
      {
        question: "What are the benefits of corporate sponsorship?",
        answer:
          "Corporate sponsors gain visibility through our marketing materials, events, and publications. More importantly, you'll make a meaningful impact on communities in need while demonstrating your organization's commitment to social responsibility. We offer various sponsorship levels to fit different budgets and goals.",
      },
    ],
  },
];

export default function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (category, index) => {
    const key = `${category}-${index}`;
    setOpenItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isOpen = (category, index) => {
    const key = `${category}-${index}`;
    return openItems[key] || false;
  };

  return (
    <div className="faq-page">
      <div className="faq-hero">
        <h1>Frequently Asked Questions</h1>
        <p>Find answers to common questions about our foundation and programs</p>
      </div>

      <div className="faq-container">
        {faqData.map((categoryData, catIndex) => (
          <div key={catIndex} className="faq-category">
            <h2 className="category-title">{categoryData.category}</h2>
            <div className="faq-items">
              {categoryData.questions.map((item, qIndex) => (
                <div
                  key={qIndex}
                  className={`faq-item ${
                    isOpen(categoryData.category, qIndex) ? "open" : ""
                  }`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleItem(categoryData.category, qIndex)}
                    aria-expanded={isOpen(categoryData.category, qIndex)}
                  >
                    <span>{item.question}</span>
                    <ChevronDown
                      className="faq-icon"
                      size={20}
                      style={{
                        transform: isOpen(categoryData.category, qIndex)
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </button>
                  <div
                    className="faq-answer"
                    style={{
                      maxHeight: isOpen(categoryData.category, qIndex)
                        ? "500px"
                        : "0",
                    }}
                  >
                    <div className="faq-answer-content">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="faq-cta">
        <h3>Still have questions?</h3>
        <p>We're here to help! Reach out to us and we'll get back to you as soon as possible.</p>
        <a href="#contact" className="contact-button">
          Contact Us
        </a>
      </div>
    </div>
  );
}
